import * as React from 'react';

import * as styles from './styles.css';

export interface IWrapperProps {
  marginTop?: number;
  marginBottom?: number;
}

export const Wrapper: React.FC<React.PropsWithChildren<IWrapperProps>> = ({ children, marginTop, marginBottom }) => {
  return (
    <div className={styles['container']} style={{ marginTop, marginBottom }}>
      {children}
    </div>
  );
};

Wrapper.displayName = 'Wrapper';
